const NotFoundPage = () => {
    return (
        <div>
            <h1>페이지를 찾을 수 없습니다</h1>
        </div>
    )
}

export default NotFoundPage;